import dynamic from "next/dynamic";

export const CaseStudyCard = dynamic(() => import("./component"));
